// Pure gating logic for the per-contact "remove from label" quick action (#162).
// Kept React-free so the part that actually regresses is unit-testable without a
// rendered tree / redux / i18n.

// System labels are managed by their own dedicated buttons (inbox / star / done /
// needs-attention / handle-later) and shouldn't be "removed" via this quick action.
// A user's own labels are `type: 'custom'`; the built-ins carry a system name/type.
export const SYSTEM_LABEL_NAMES = new Set([
    'all', 'inbox', 'inbox zero', 'handle later', 'needs attention',
    'unread', 'starred', 'done', 'snoozed',
]);

export const isSystemLabel = (label: { name?: string; type?: string } | undefined): boolean => {
    if (!label) return true;
    if (label.type === 'default') return true;
    return SYSTEM_LABEL_NAMES.has((label.name ?? '').toLowerCase());
};

/**
 * The quick "remove from label" affordance is meaningful only while a real user
 * label is the active view AND this contact actually belongs to it.
 */
export const shouldShowRemoveFromLabel = (args: {
    activeLabelId: string | undefined;
    activeLabel: { name?: string; type?: string } | undefined;
    contactLabel: unknown;
}): boolean => {
    const { activeLabelId, activeLabel, contactLabel } = args;
    if (!activeLabelId) return false;
    if (isSystemLabel(activeLabel)) return false;
    return Boolean(contactLabel);
};
